<template>
  <div class="circle">
    <div class="content top">{{ content1 }}</div>
    <div class="content right">{{ content2 }}</div>
    <div class="content bottom">{{ content3 }}</div>
    <div class="content left">{{ content4 }}</div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    title: String,
  },
  setup(props) {
    const content1 = ref("");
    const content2 = ref("");
    const content3 = ref("");
    const content4 = ref("");
    console.log(props.title);
    window.addEventListener("scroll", () => {
      if (props.title === "Works") {
        content1.value = "AWS";
        content2.value = "Vue.js";
        content3.value = "内製化支援";
        content4.value = "サーバーレス";
      } else if (props.title === "Personal Activity") {
        content1.value = "Web 学習教材";
        content2.value = "進路支援動画サイト";
        content3.value = "学習スペース materix Lab";
        content4.value = "AWS 学習サイト";
      } else if (props.title === "About Me") {
        content1.value = "🍣";
        content2.value = "🍣";
        content3.value = "🍣";
        content4.value = "🍣";
      }
    });

    return { content1, content2, content3, content4 };
  },
});
</script>

<style scoped>
.circle {
  width: 87vh;
  height: 87vh;
  min-width: 600px;
  min-height: 600px;
  /* border: 1px solid rgb(185, 185, 185); */
  border-radius: 50%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  z-index: -1;
}

.circle-container:hover {
  /* width: 100vh;
  height: 10vh; */
  border: 1px solid rgb(215, 46, 46);
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 50%;
  position: absolute;
  left: 25%;
  top: 25%;
  /* border: 1px solid #333; */
}

/* top */
.top {
  animation: rotate_top 50s linear infinite;
}
@keyframes rotate_top {
  0% {
    transform: rotate(0deg) translateY(-100%) rotate(0deg);
  }
  100% {
    transform: rotate(-360deg) translateY(-100%) rotate(360deg);
  }
}

/* right */
.right {
  animation: rotate_right 50s linear infinite;
}
@keyframes rotate_right {
  0% {
    transform: rotate(0deg) translateX(100%) rotate(0deg);
  }
  100% {
    transform: rotate(-360deg) translateX(100%) rotate(360deg);
  }
}

/* bottom */
.bottom {
  animation: rotate_bottom 50s linear infinite;
}
@keyframes rotate_bottom {
  0% {
    transform: rotate(0deg) translateY(100%) rotate(0deg);
  }
  100% {
    transform: rotate(-360deg) translateY(100%) rotate(+360deg);
  }
}

/* left */
.left {
  animation: rotate_left 50s linear infinite;
}
@keyframes rotate_left {
  0% {
    transform: rotate(0deg) translateX(-100%) rotate(0deg);
  }
  100% {
    transform: rotate(-360deg) translateX(-100%) rotate(360deg);
  }
}
</style>